export const getAdManagerState = (state: {
  monetization: bb.state.IMonetization;
}) => state.monetization;

export const getHWAccountStatus = (state: {
  monetization: { workState: bb.model.monetization.IHWAccountStatus };
}) => {
  return state.monetization.workState;
};
export const getHWUserInfo = (state: {
  monetization: { accountInfo: bb.model.monetization.IHWAccountInfo };
}) => {
  return state.monetization.accountInfo;
};

export const getPaymentTransactions = (state: {
  monetization: {
    paymentHistory: {
      transactions: bb.model.monetization.IAdPaymentTransaction[];
    };
  };
}) => {
  return state.monetization.paymentHistory.transactions;
};
export const getProjects = (state: {
  monetization: {
    projects: {
      games: bb.model.monetization.IAdProject[];
    };
  };
}) => {
  return state.monetization.projects.games;
};

export const getAdboxReport = (state: {
  monetization: {
    adboxReport: bb.model.monetization.IAdboxReport
  }
}) => {
  return state.monetization.adboxReport
}

export const getAdboxMonthDateEarnings = (state: {
  monetization: {
    monthToDateEarnings: bb.model.monetization.IAdboxMonthToDateEarnings
  }
}) => {
  return state.monetization.monthToDateEarnings;
}

export const getFilteredReport = (state: {
  monetization: {
    filters: any
  }
}) => {
  return state.monetization.filters;
}

export const getDailyMetrics = (state: {
  monetization: {
    adboxDailyMetrics: bb.model.monetization.IAdboxDailyMetrics
  }
}) => {
  return state.monetization.adboxDailyMetrics;
}
